import { NATURE_EFFECTS } from '../mock/data.ts';
import type { StatBlock } from '../types.ts';

const STAT_LABEL: Record<keyof StatBlock, string> = {
  hp: 'HP',
  atk: 'Atk',
  def: 'Def',
  spa: 'SpA',
  spd: 'SpD',
  spe: 'Spe',
};

// Replaces verbose nature names ("Jolly", "Timid", etc.) with ▲stat / ▼stat
// glyphs. The verbose nature names are jargon that gatekeeps newer players;
// the up/down arrows show the actual mechanical effect.
//
// Returns null for neutral natures (Hardy/Docile/etc.) — they're informational
// noise that crowds the team card.
export function NatureGlyph({ nature, size = 'sm' }: { nature: string; size?: 'sm' | 'md' }) {
  const effect = NATURE_EFFECTS[nature];
  if (!effect) return null;
  const fontSize = size === 'sm' ? 9.5 : 11;
  return (
    <span
      className="caps mono"
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 4,
        fontSize,
        letterSpacing: '0.06em',
        color: 'var(--fg-2)',
      }}
      title={`${nature} (+${STAT_LABEL[effect.up]} -${STAT_LABEL[effect.down]})`}
    >
      <span style={{ color: 'var(--pos)' }}>▲{STAT_LABEL[effect.up]}</span>
      <span style={{ color: 'var(--neg)' }}>▼{STAT_LABEL[effect.down]}</span>
    </span>
  );
}
